module.exports = __webpack_public_path__ + "img/galeria.9670eb13.png";